import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from "gsap/CustomEase";
import { SplitText } from "gsap/SplitText";
import Swiper from 'swiper/bundle';
import Lenis from '@studio-freight/lenis';
import Vivus from 'vivus';
// import Swup from 'swup';
// import SwupDebugPlugin from '@swup/debug-plugin';


/*-------------------------------------
 Lenis設定（スムーススクロール）
--------------------------------------*/
const lenis = new Lenis();
function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);


/*-------------------------------------
 スクロール時の処理
--------------------------------------*/
let startPos = 0;
let winScrollTop = 0;
let threshold = window.innerHeight * 0.5;
window.addEventListener('scroll', () => {
  winScrollTop = window.scrollY;

  if (winScrollTop !== 0) {
    document.body.classList.add('is-scroll');
  } else {
    document.body.classList.remove('is-scroll');
  }

  if (winScrollTop >= startPos) {
    if (winScrollTop >= threshold) {
      document.body.classList.add('is-down');
    }
  } else {
    document.body.classList.remove('is-down');
  }
  startPos = winScrollTop;
});
window.addEventListener('resize', () => {
  threshold = window.innerHeight;
});

/*-------------------------------------
 GSAP ScrollTrigger
--------------------------------------*/
gsap.registerPlugin(ScrollTrigger);

function createScrollTrigger(selector, start, className, markers = false, pin = false) {
  const elements = document.querySelectorAll(selector);
  elements.forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      id: index + 1,
      start: start,
      toggleClass: { targets: el, className: className },
      once: true,
      markers: markers,
			pin: pin,
    });
  });
}

/*-------------------------------------
 メニュー開閉・トグル関連
--------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
  createScrollTrigger('.fadeUp','top 75%','is-active');
  document.body.classList.add('is-ready');
  
  const menuButton = document.getElementById('menuButton');
  const gnav = document.getElementById('gnav');
  let isMenuOpen = false;
  let scrollPos = 0;

  menuButton.addEventListener('click', () => {
    menuButton.classList.toggle('show');
    gnav.classList.toggle('show');
    if (!isMenuOpen) {
      scrollPos = window.scrollY;
      document.body.classList.add('fixed');
      document.body.style.top = `-${scrollPos}px`;
      isMenuOpen = true;
    } else {
      closeMenu();
    }
  });

  function closeMenu() {
    menuButton.classList.remove('show');
    gnav.classList.remove('show');
    document.body.classList.remove('fixed');
    document.body.style.top = '0';
    window.scrollTo(0, scrollPos);
    isMenuOpen = false;
  }

  Array.from(gnav.querySelectorAll('a')).forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  // メニュー以外をクリックしたら閉じる
  document.addEventListener('click', (e) => {
    if (!gnav.contains(e.target) && !menuButton.contains(e.target) && isMenuOpen) {
      closeMenu();
    }
  });

  // リサイズ対応
  function handleResize() {
    if (window.innerWidth >= 768) {
      document.body.classList.remove('fixed');
      document.body.style.top = '0';
    }
  }
  window.addEventListener('load', handleResize);
  window.addEventListener('resize', handleResize);

  /*-------------------------------------
   ページトップボタン
  --------------------------------------*/
  const pagetop = document.getElementById('pagetop');
  if (pagetop) {
    pagetop.addEventListener('click', () => {
      lenis.scrollTo(0);
    });
    window.addEventListener('scroll', (e) => {
      const scrollTop = window.pageYOffset;
      const footer = document.querySelector('footer');
      
      // スクロールが20pxを超えたらis-scrollクラスを追加
      if (scrollTop >= 20) {
        pagetop.classList.add('is-scroll');
      } else {
        pagetop.classList.remove('is-scroll');
      }

    });
  }

  const anchorTarget = document.querySelector('.type_anchor .inner');
  if (anchorTarget) {
    const titles = document.querySelectorAll('.anchor');
    let anchorText = '';
    
    titles.forEach(title => {
      const id = title.getAttribute('id');
      const text = title.nextElementSibling.textContent;
      anchorText += `<li><a href="#${id}">${text}</a></li>`;
    });
    anchorTarget.innerHTML = `<ul>${anchorText}</ul>`;
    
  }

  // まずセレクタにマッチする要素が存在するか確認
  const anchors = document.querySelectorAll('a[href^="#"], a[href^="/#"], .anchors a');

  anchors.forEach(anchor => {
    
    anchor.addEventListener('click', function(event) {
      console.log('Anchor clicked:', this.getAttribute('href'));
      
      const href = this.getAttribute('href');
      if (!href || href.startsWith('mailto:') || !href.includes('#')) return;
      
      const targetId = href.includes('#') ? href.split('#')[1] : null;
      if (!targetId) return;
      
      const targetElement = document.getElementById(targetId);
      console.log('Target element:', targetId, targetElement);
      
      if (targetElement) {
        event.preventDefault();
        const rectTop = targetElement.getBoundingClientRect().top + window.scrollY;
        lenis.scrollTo(rectTop);
      }
    });
  });

  const faqElements = document.querySelectorAll('.type_faq');
  if (faqElements.length) {
    faqElements.forEach(faq => {
      const questions = faq.querySelectorAll('.q');
      questions.forEach(question => {
        question.addEventListener('click', () => {
          question.classList.toggle('active');
          const nextElement = question.nextElementSibling;
          
          if (nextElement.style.display === 'none' || !nextElement.style.display) {
            nextElement.style.display = 'block';
          } else {
            nextElement.style.display = 'none';
          }
        });
      });
    });
  }
});


/*-------------------------------------
 フッター固定ボタンのスクロール処理
--------------------------------------*/
let fixedFooterStartPos = 0;
const fixedFooterButton = document.getElementById('fixedFooterButton');

// jQueryを使わないES6の書き方に変更　
window.addEventListener('scroll', () => {
  const winScrollTop = window.scrollY;
  const documentHeight = document.documentElement.scrollHeight;
  const footerHeight = document.querySelector('footer').offsetHeight;
  const windowHeight = window.innerHeight;
  
  if (fixedFooterButton) {
    if (winScrollTop > 500 && winScrollTop < documentHeight - footerHeight - windowHeight) {
      fixedFooterButton.classList.add('is-scroll');
    } else {
      fixedFooterButton.classList.remove('is-scroll');
    }
  }
  fixedFooterStartPos = winScrollTop;
});

const planSlide = new Swiper('#planSlide', {
  centeredSlides: true,
  slidesPerView: 1.25,
  loop: true,
  breakpoints: {
    768: {
      slidesPerView: 1.55,
    },
    1440: {
      slidesPerView: 1.8,
    },
    1680: {
      slidesPerView: 2,
    },
  },
});

const caseSlider = new Swiper('.caseSlider', {
  centeredSlides: true,
  slidesPerView: "auto",
  loop: true,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
});

const topCaseSlider = new Swiper('.topCaseSlider', {
  centeredSlides: true,
  slidesPerView: "auto",
  loop: true,
  autoplay: {
    delay: 2000,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      centeredSlides: false,
    },
  },
});

function animatePath(pathId, trigger, animationType) {
  const path = document.querySelector(pathId);
  if(path) {
    const drawPath = new Vivus(path, {
      type: "oneByOne",
      duration: 30,
      animTimingFunction: animationType,
      forceRender: false,
    });
    gsap.fromTo(
      path,
      {
        autoAlpha: 1
      },
      {
        autoAlpha: 1,
        duration: 100,
        scrollTrigger: {
          trigger: trigger,
          start: 'top 50%',
          // markers: true,
          onEnter: () => {
            drawPath.play();
          },
        }
      }
    );
  }
}

animatePath('#path-01', '.feature01', Vivus.EASE_IN);
animatePath('#path-02', '.feature02', Vivus.EASE_IN);
animatePath('#path-03', '.feature03', Vivus.EASE_IN);
animatePath('#path-04', '.feature04', Vivus.EASE_IN);
animatePath('#path-06', '.feature05', Vivus.EASE_IN);
animatePath('#path-07', '.feature06', Vivus.EASE_IN);

const accordions = document.querySelectorAll(".solutionFAQList .unit");

const openAccordion = (accordion) => {
	const content = accordion.querySelector(".a");
	accordion.classList.add("is-active");
	content.style.maxHeight = content.scrollHeight + "px";
};

const closeAccordion = (accordion) => {
	const content = accordion.querySelector(".a");
	accordion.classList.remove("is-active");
	content.style.maxHeight = null;
};

accordions.forEach((accordion) => {
	const intro = accordion.querySelector(".q");
	const content = accordion.querySelector(".a");

	intro.onclick = () => {
		if (content.style.maxHeight) {
			closeAccordion(accordion);
		} else {
			accordions.forEach((accordion) => closeAccordion(accordion));
			openAccordion(accordion);
		}
	};
});


gsap.registerPlugin(SplitText) 

var ttSP = gsap.timeline(),
  mySplitText = new SplitText("#topTitle .sp", {
    type: "lines, words",
    linesClass: "line"
  }),
  words = mySplitText.words;

ttSP.from(words, {
  duration: 0.8,
  opacity: 0,
  yPercent: 120,
  ease: "power",
  stagger: 0.1
});

var ttPC = gsap.timeline(),
  mySplitText = new SplitText("#topTitle .pc", {
    type: "lines, words",
    linesClass: "line"
  }),
  words = mySplitText.words;

ttPC.from(words, {
  duration: 0.8,
  opacity: 0,
  yPercent: 120,
  ease: "power",
  stagger: 0.1
});

var ttLP = gsap.timeline(),
  mySplitText = new SplitText("#lpTitle", {
    type: "lines, words",
    linesClass: "line"
  }),
  words = mySplitText.words;

ttLP.from(words, {
  duration: 0.8,
  opacity: 0,
  yPercent: 120,
  ease: "power",
  stagger: 0.1
});

document.addEventListener("DOMContentLoaded", function() {
  var path = window.location.pathname;
  var match = path.match(/^\/([^\/]+)\//);
  var rootPath = match ? "/" + match[1] + "/" : "/";

  var gnav = document.getElementById('gnav');
  if (gnav) {
    var links = gnav.querySelectorAll('a[href]');
    links.forEach(function(link) {
      // #から始まるhrefを除外
      if (link.getAttribute('href').startsWith('#')) {
        return;
      }
      var a = document.createElement("a");
      a.href = link.href;
      if (
        a.host === window.location.host
        && a.pathname.startsWith(rootPath)
      ) {
        if (
          (rootPath === "/" && a.pathname === "/") ||
          (rootPath !== "/" && a.pathname.startsWith(rootPath))
        ) {
          link.classList.add("is-active");
        }
      }
    });
  }
});
